import React, { useEffect } from 'react';

//import { AuthContext } from '@starterapp/shared-services/authentication/AuthContext';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';

const PoiRedirect = ({ someLocation }) => {
    const location = useLocation();
    const history = useHistory();
    const params = new URLSearchParams(location.search);

    // IMPORTANT - ref number back from POI - need to save this to Temporary Storage at some point
    const referenceNumber = params.get('referenceNumber');
    console.log('POI referenceNumber', referenceNumber);

    useEffect(() => {
        (async () => {
            const routeName = localStorage.getItem('poiRedirectTo');

            if (routeName) {
                sessionStorage.setItem('hasRedirectedToPoi', true);
                history.push(routeName);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            PoiRedirect...
        </div>
    );
};

export default PoiRedirect;
